import * as React from "react";

export type AiStatusPillVariant = "accepted" | "rejected" | "edited";

export type AiStatusPillProps = {
  variant: AiStatusPillVariant;
  label?: string;
  className?: string;
};

const LABELS: Record<AiStatusPillVariant, string> = {
  accepted: "Accepted",
  rejected: "Rejected",
  edited: "Edited",
};

/** Soft status chip — Accepted / Rejected / Edited. */
export const AiStatusPill: React.FC<AiStatusPillProps> = ({
  variant,
  label,
  className,
}) => (
  <span
    className={`ai-status-pill ai-status-pill--${variant}${className ? ` ${className}` : ""}`}
  >
    {label ?? LABELS[variant]}
  </span>
);

export default AiStatusPill;
